import {
  Box,
  ListItem,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import * as React from "react";

import { EditFieldButton } from "@/shared/components/EditFieldButton";
import {
  TriggerForEachPrimitive,
  UpdateTriggerRequest,
} from "@/shared/domain/actions/TriggerRecord";

import { TriggerForEachSelector } from "./TriggerForEachSelector";

interface EditableForEachSelectorProps {
  title: string;
  field: string;
  value: TriggerForEachPrimitive;
  onChange: (updates: UpdateTriggerRequest) => void;
  setErrorText: (arg: string) => void;
}

export const EditableForEachSelector: React.FC<
  EditableForEachSelectorProps
> = ({ title, field, value, onChange, setErrorText }) => {
  const theme = useTheme();
  const [showEditableIcon, setShowEditableIcon] = React.useState(false);
  const [editable, setEditable] = React.useState(false);
  const [currentValue, setCurrentValue] = React.useState(value);

  const updateRecord = (updatedVal: string) => {
    setErrorText("");

    onChange({
      [field]: updatedVal,
    });
  };

  const onClick = () => {
    if (editable && currentValue) {
      updateRecord(currentValue);
    }
    setEditable(!editable);
  };

  return (
    <ListItem
      onMouseOver={() => {
        setShowEditableIcon(true);
      }}
      onMouseLeave={() => {
        setShowEditableIcon(false);
      }}
    >
      <ListItemText
        primaryTypographyProps={{
          component: "span",
        }}
        sx={{
          mt: theme.spacing(0.5),
        }}
        primary={
          <>
            <span>{title}</span>

            <EditFieldButton
              editable={editable}
              showEditableIcon={showEditableIcon}
              onClick={() => {
                void onClick();
              }}
            />

            <Box>
              {editable === false ? (
                <Typography
                  component="span"
                  variant="body2"
                  style={{
                    whiteSpace: "pre-wrap",
                    color: theme.palette.text.secondary,
                  }}
                >
                  <>{currentValue}</>
                </Typography>
              ) : (
                <Box
                  sx={{
                    mt: theme.spacing(1),
                  }}
                >
                  <TriggerForEachSelector
                    forEach={currentValue}
                    setForEach={setCurrentValue}
                  />
                </Box>
              )}
            </Box>
          </>
        }
      />
    </ListItem>
  );
};
